import { DayPilot } from 'daypilot-pro-react'
import { format } from 'date-fns'

type TimelineItem = { start: DayPilot.Date; end: DayPilot.Date }

export const getCustomTimeline = (selectedDate: Date, nightView: boolean): TimelineItem[] => {
  const timeline: TimelineItem[] = []
  // The start time of the timeline set in settings
  const customStartTime = nightView ? '12:00:00' : '00:00:00'
  const formattedDate = format(selectedDate, 'yyyy-MM-dd') + 'T' + customStartTime // To get the format YYYY-MM-DDT:HH:mm:ss
  const date = new DayPilot.Date(formattedDate)

  // Creating every 30mins cells for the view
  for (let h = 0; h < 24 * 2; h++) {
    const start = date.addMinutes(h * 30)
    const end = start.addMinutes(30)
    timeline.push({ start, end })
  }

  return timeline
}
